var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSearchIc(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.8801 15.1601C3.8481 15.1601 0.600098 11.9121 0.600098 7.8801C0.600098 3.8481 3.8481 0.600098 7.8801 0.600098C11.9121 0.600098 15.1601 3.8481 15.1601 7.8801C15.1601 11.9121 11.9121 15.1601 7.8801 15.1601ZM7.8801 1.7201C4.4641 1.7201 1.7201 4.4641 1.7201 7.8801C1.7201 11.2961 4.4641 14.0401 7.8801 14.0401C11.2961 14.0401 14.0401 11.2961 14.0401 7.8801C14.0401 4.4641 11.2961 1.7201 7.8801 1.7201Z",
    fill: "#BDC2E3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3021 12.5095L18.3309 17.5383L17.5391 18.3302L12.5103 13.3014L13.3021 12.5095Z",
    fill: "#BDC2E3"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchIc);
export default __webpack_public_path__ + "static/media/search-ic.d883d32041a35e5ffd40f9b234ab3a90.svg";
export { ForwardRef as ReactComponent };